import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Subscription} from 'rxjs';
import {EquipmentDataFlowService} from '../services/equipment-data-flow.service';
import {EquipmentEnums} from '@namespaces/equipment.namespace';
import {EquipmentCardInterfaces} from '@namespaces/equipment.namespace';

@Component({
    selector: 'app-equipment-view-layout',
    templateUrl: 'equipment-view-layout.component.html'
})

export class EquipmentViewLayoutComponent implements OnInit, OnDestroy {

    @Input() equipment: EquipmentCardInterfaces.Card.ItemView;

    @Output() edit = new EventEmitter();
    @Output() addCalibration = new EventEmitter();
    @Output() addRepair = new EventEmitter();

    public isMaterial = false;

    private subs: Subscription[] = [];

    constructor(
        private dataService: EquipmentDataFlowService,
    ) {
    }

    ngOnInit() {
        this.subs.push(
            this.dataService.onEdit$.subscribe(() => this.edit.emit()),
            this.dataService.addCalibration$.subscribe(() => this.addCalibration.emit()),
            this.dataService.addRepair$.subscribe(() => this.addRepair.emit()),
        );

        this.isMaterial = this.equipment.apparatus.type === EquipmentEnums.Type.material;
    }

    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
    }
}
